import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

// Legacy path, kept only so existing bookmarks keep working. It used to be the
// landing target for the worker's unauthed '/' redirect, back when '/' served the
// map editor; it then bounced straight back to '/' to get there. Now '/' IS the
// landing page, so this is a plain forward with nothing to loop against.
export const Route = createFileRoute('/manage')({ component: RedirectToHome })

function RedirectToHome() {
  useEffect(() => {
    window.location.replace('/')
  }, [])

  return <p role="status" className="text-center text-sm text-ink-soft py-16">Redirecting…</p>
}
